import { FC } from 'react'
import './index.less'
import PerIcon from '../Icon'
import { isDefined } from '../../../types.helper'

export interface TrueFalseSwitchProps {
  onValueChanged: (value: boolean) => void
}

interface ButtonProps {
  currentValue?: boolean
  disabled?: boolean
}

const TrueFalseSwitch: FC<TrueFalseSwitchProps & ButtonProps> = ({ currentValue, onValueChanged, disabled }) => {
  const trueSelected = currentValue ? 'tf-selected-true' : 'tf-selected-none'
  const falseSelected = isDefined(currentValue) && !currentValue ? 'tf-selected-false' : 'tf-selected-none'
  const hover = disabled ? 'tf-switch--hover-disabled' : 'tf-switch--hover'

  return (
    <div className="tf-container">
      <div
        data-e2e-true-switch
        className={`tf-switch tf-switch--pastel true-switch   ${trueSelected} ${hover}`}
        onClick={() => disabled || onValueChanged(true)}
      >
        <PerIcon name="check_stroke" variant="clickable" size={16} />
      </div>
      <div
        data-e2e-false-switch
        className={`tf-switch tf-switch--pastel false-switch  ${falseSelected} ${hover}`}
        onClick={() => disabled || onValueChanged(false)}
      >
        <PerIcon name="close_stroke" variant="clickable" size={16} />
      </div>
    </div>
  )
}

export default TrueFalseSwitch
